export default "__VITE_ASSET__a281f64d__"